import {Dimensions, Platform} from 'react-native';
import {globalConfigurableData, globalConst} from '../utils/globalConstant';
import {isMobileCheck} from '../utils/commonMethods';

let {width, height} = Dimensions.get('window');

width =
  globalConfigurableData.isMobileViewInDesktop && !isMobileCheck()
    ? 420
    : width;

export default {
  width,
  height,
};
